export default __webpack_public_path__ + "assets/thermometer-glass-fahrenheit.b8623875.svg";